import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_SECONDS_FORMAT } from 'src/app/core/ccomx-date-formats';
import { UserDrillsRoutes } from '../../../../../core/enums/routes.enum';
import { DrillsActionType } from '../../../../../drills-user/components/enum/drills-action-type';

@Component({
  selector: 'app-drills-log-template',
  templateUrl: './drills-log-template.component.html',
  styleUrls: ['./drills-log-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DrillsLogTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  drillActionTypes = DrillsActionType;
  performViewRoute = UserDrillsRoutes.PerformView;
  dateFormat = DEFAULT_DATE_TIME_SECONDS_FORMAT;
}
